import { Draggable, Droppable } from '@hello-pangea/dnd';
import React from 'react';
import { PromptExtended } from '@/components/GamePacks/Prompts/PromptList';
import SelectedPromptCard from '@/components/GamePacks/Prompts/SelectedPromptCard';

interface DroppablePromptListProps {
  prompts: PromptExtended[];
  droppableId: string;
  emptyMessage: string;
  setSelectedPrompts: React.Dispatch<React.SetStateAction<PromptExtended[]>>;
}

export default function DroppablePromptList({
  prompts,
  droppableId,
  emptyMessage,
  setSelectedPrompts
}: DroppablePromptListProps) {
  return (
    <Droppable droppableId={droppableId}>
      {(provided) => (
        <>
          {prompts.length === 0 && <p>{emptyMessage}</p>}
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={`flex flex-col w-full gap-12`}
          >
            {prompts.map((prompt, index) => (
              <Draggable key={prompt.id} draggableId={prompt.id} index={index}>
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <SelectedPromptCard
                      text={prompt.text}
                      gamePack={prompt.gamePack}
                      onRemove={() => {
                        setSelectedPrompts((prev) => prev.filter((p) => p.id !== prompt.id));
                      }}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        </>
      )}
    </Droppable>
  );
}
